import { Card, Heading } from "@digdir/designsystemet-react";
import { ChevronRightIcon } from "@navikt/aksel-icons";
import { Link } from "@tanstack/react-router";
import type { MalerdataPeriode } from "@/api/generated";
import type { MonthlyPeriodSearchParam } from "@/routes/_app/_subheader/maalerdata/periode";
import {
  formatDateStringInterval,
  getMonthStringFromDate,
} from "@/utils/dateTimeUtils";
import { OpplastingStatus } from "./periode/OpplastingStatus";

export const MaaledataPeriodeCard = ({
  periode,
}: {
  periode: MalerdataPeriode;
}) => {
  const getRegistrerParams = (
    periode: MalerdataPeriode,
  ): MonthlyPeriodSearchParam => {
    const fromDate = new Date(periode.fraInklusiv);

    return {
      month: fromDate.getMonth() + 1,
      year: fromDate.getFullYear(),
    };
  };

  return (
    <Card key={periode.fraInklusiv + periode.tilEksklusiv} asChild>
      <Link to="/maalerdata/periode" search={() => getRegistrerParams(periode)}>
        <div className="flex flex-row justify-between items-center">
          <div className="flex flex-col gap-2">
            <OpplastingStatus opplastingStatus={periode.opplastingStatus} />
            <div>
              <Heading level={3} className="no-underline">
                {`Målerdata for ${getMonthStringFromDate(new Date(periode.fraInklusiv))}`}
              </Heading>
              <span className="text-balder-text-subtle">
                {formatDateStringInterval(
                  periode.fraInklusiv,
                  periode.tilEksklusiv,
                )}
              </span>
            </div>
          </div>

          <div className="p-2 flex items-center">
            <ChevronRightIcon fontSize={"1.5rem"} />
          </div>
        </div>
      </Link>
    </Card>
  );
};
